import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Search } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import heroImage from '@/assets/hero-wedding.jpg';

const HeroSection = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = () => {
    const trimmed = searchQuery.trim();
    if (trimmed) {
      navigate(`/vendors?q=${encodeURIComponent(trimmed)}`);
    } else {
      navigate('/vendors');
    }
  };

  return (
    <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src={heroImage}
          alt="Romantic wedding ceremony"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background/60 via-background/40 to-background/80" />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center">
        <div className="max-w-4xl mx-auto">
          <span className="inline-block text-primary font-medium mb-4 animate-fade-in opacity-0" style={{ animationDelay: '0.1s' }}>
            Tu boda, a tu manera
          </span>
          
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl font-semibold text-foreground mb-6 animate-fade-in-up opacity-0" style={{ animationDelay: '0.2s' }}>
            Planifica tu boda perfecta
            <span className="block text-primary">sin intermediarios</span>
          </h1>
          
          <p className="text-lg md:text-xl text-muted-foreground mb-8 max-w-2xl mx-auto animate-fade-in-up opacity-0" style={{ animationDelay: '0.4s' }}>
            Descubre y conecta directamente con los mejores proveedores de bodas. 
            Lugares, catering, fotografía, flores y mucho más en un solo lugar.
          </p>

          {/* Search Bar */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8 animate-fade-in-up opacity-0" style={{ animationDelay: '0.6s' }}>
            <div className="relative w-full sm:w-96">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    handleSearch();
                  }
                }}
                placeholder="¿Qué estás buscando?"
                className="w-full h-14 pl-12 pr-4 rounded-xl border border-border bg-card/90 backdrop-blur-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/50 transition-all"
              />
            </div>
            <Button variant="hero" size="xl" onClick={handleSearch}>
              Explorar
            </Button>
          </div>

          {/* Quick Links */}
          <div className="flex flex-wrap justify-center gap-3 animate-fade-in-up opacity-0" style={{ animationDelay: '0.8s' }}>
            <Link to="/vendors?category=venue">
              <Button variant="romantic" size="sm">🏰 Lugares</Button>
            </Link>
            <Link to="/vendors?category=photography">
              <Button variant="romantic" size="sm">📸 Fotografía</Button>
            </Link>
            <Link to="/vendors?category=catering">
              <Button variant="romantic" size="sm">🍽️ Catering</Button>
            </Link>
            <Link to="/vendors?category=flowers">
              <Button variant="romantic" size="sm">💐 Flores</Button>
            </Link>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background to-transparent z-10" />
    </section>
  );
};

export default HeroSection;
